<template>
  <div class="progress-container" :style="{ color: color }">
    <div
      class="progress"
      ref="progress"
      :style="{ width: width, borderColor: color }"
    >
      <div
        class="progress-portion"
        ref="progressPortion"
        :style="{ background: color }"
      ></div>
    </div>
    <span v-if="isShowValue" class="progress-value">{{ value }}</span>
    <span v-if="isShowText" class="progress-label">分</span>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "3.5rem",
    },
    color: {
      type: [String, Array],
      default: "",
    },
    value: {
      type: [String, Number],
      default: 0,
    },
    isShowValue: {
      type: Boolean,
      default: true,
    },
    isShowText: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value: {
      handler() {
        this.$nextTick(() => {
          this.calcWidth();
        });
      },
    },
  },
  methods: {
    calcWidth() {
      console.log(this.$refs.progress.offsetWidth);
      const w = (this.$refs.progress.offsetWidth / 100) * this.value;
      console.log(w);
      this.$refs.progressPortion.style.width = w + "px";
    },
  },
  mounted() {
    this.calcWidth();
  },
};
</script>

<style lang="less" scoped>
.progress-container {
  display: flex;
  align-items: center;
  .progress {
    position: relative;
    // width: 3.5rem;
    min-height: 0.3rem;
    border-radius: 1rem;
    padding: 0.03rem 0.02rem;
    border: 1px solid;
    .progress-portion {
      height: 0.24rem;
      border-radius: 1.5rem;
    }
  }
  .progress-value {
    // position: absolute;
    // right: -0.7rem;
    margin-left: 0.1rem;
    width: 16px;
  }
  .progress-label {
    // position: absolute;
    // right: -1.2rem;
    width: 16px;
    font-size: 0.35rem;
  }
}
</style>